<!--
 * @Description:
 * @Author: PF
 * @Date: 2023-07-17 15:23:51
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">请假</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
      <el-container>
        <el-header>
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
          <el-form-item>
            <el-select placeholder="请假状态" v-model="dataGrid.parms.zt" clearable filterable @change="bindTable()">
              <el-option v-for="(item, index) in qjztData.listZhuangTai" :key="index" :label="item.name" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select placeholder="请假类型" v-model="dataGrid.parms.qjlxid" clearable filterable @change="bindTable()">
              <el-option v-for="(item, index) in jzgqjlxData" :key="index" :label="item.bt" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select placeholder="销假状态" v-model="dataGrid.parms.zt" clearable filterable @change="bindTable()">
              <el-option v-for="(item, index) in xjztData.listZhuangTai" :key="index" :label="item.name" :value="item.value" />
            </el-select>
          </el-form-item>
          </el-form>
          <!-- 搜索区域 END -->
          <!-- 按钮区域 BEGIN -->
          <div class="button-box">
            <el-button type="primary" @click="openAdd=true"><span class="iconfont icon-chuangjian"></span>添加</el-button>
          </div>
          <!-- 按钮区域 END -->
        </el-header>
        <el-main>
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <el-table-column label="序号" type="index" align="center" width="80" />
            <el-table-column label="请假类型" prop="qjlxbt" align="center" sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="请假时间" prop="qjkssj" align="center" width="260" sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                {{scope.row.qjkssj}}<span class="ml5 mr5">-</span>{{scope.row.qjjssj}}
              </template>
            </el-table-column>
            <el-table-column label="请假天数" prop="qjts" align="center" show-overflow-tooltip>
              <template #default="scope">
                <span>{{scope.row.qjts}}天</span>
              </template>
            </el-table-column>
            <el-table-column label="请假原因" prop="qjyy" align="center" show-overflow-tooltip />
            <el-table-column label="请假状态" prop="zt" align="center" sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span v-for="(item, index) in qjztData.listZhuangTai" :key="index">
                  <span v-if="scope.row.zt==item.value">{{item.name}}</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="销假状态" prop="xjzt" align="center" sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span v-for="(item, index) in xjztData.listZhuangTai" :key="index">
                  <span v-if="scope.row.xjzt==item.value">{{item.name}}</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="是否需要调代课" prop="sfxqtdk" width="140" align="center">
              <template #default="scope">
                <span v-if="scope.row.sfxqtdk==true">是</span>
                <span v-if="scope.row.sfxqtdk==false">否</span>
              </template>
            </el-table-column>
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="240" fixed="right" align="center">
              <template #default="scope">
                <el-button link type="primary" @click="openDetail=true;tcRow=scope.row">审批详情</el-button>
                <el-button link type="primary" v-if="scope.row.zt==qjztData.ylr || scope.row.zt==qjztData.jj" @click="tiJiaoClick(scope.row)">提交</el-button>
                <el-button link type="primary" v-if="scope.row.zt==qjztData.shtg && (scope.row.xjzt==xjztData.wxj || scope.row.xjzt==xjztData.jj)" @click="xiaohuiClick(scope.row)">
                  销假
                </el-button>
                <el-button link type="primary" v-if="scope.row.zt==qjztData.ylr || scope.row.zt==qjztData.jj" @click="openEdit=true;tcRow=scope.row">修改</el-button>
                <el-button link type="warning" v-if="scope.row.zt==qjztData.ylr || scope.row.zt==qjztData.jj" @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
        <el-footer>
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </el-footer>
      </el-container>
    </div>
    </el-dialog>
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" @ReturnData="bindTable" />
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="tcRow" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="tcRow" />

  <div class="tan-chuang">
    <el-dialog class="w600 h530" v-model="centerDialogVisible" title="销假" width="500px">
      <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="120px" status-icon>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="请假时间" prop="sjqjkssj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="qjsj" type="datetimerange" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" value-format="YYYY-MM-DD HH:mm" format="YYYY-MM-DD HH:mm" @change="qjsjChange" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="实际请假天数" prop="sjqjts">
              <el-input-number v-model="ruleForm.sjqjts" :min="0" :precision="1" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer-but">
            <el-button type="primary" @click="submitForm()">保存</el-button>
            <el-button @click="guanbixiaojia">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, unref } from 'vue'

import {
  loadList,
  submitDataGridAction,
  loadSelect,
  actionPost,
  homeCloseWindow
} from '@/api/common.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import { loadZiDianSelect } from '@/api/queryZiDian.js'
import pagination from '@/components/pagination.vue'
import { ElMessageBox } from 'element-plus'
import add from './add.vue'
import edit from './edit.vue'
import detail from './detail.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const ruleForm = ref({})
const ruleFormRef = ref(null)
const centerDialogVisible = ref(false)
// 销假
const xiaojiaid = ref()
const xiaohuiClick = (row, val) => {
  xiaojiaid.value = row.id
  centerDialogVisible.value = true

  ruleForm.value.sjqjts = row.qjts
  qjsj.value = [row.qjkssj, row.qjjssj]
  ruleForm.value.sjqjkssj = row.qjkssj
  ruleForm.value.sjqjjssj = row.qjjssj
}
// 提交
const tiJiaoClick = (item) => {
  ElMessageBox.confirm('确定提交吗?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',

    type: 'warning'
  }).then(() => {
    const o = {
      url: '/api/v2/jiaowu/jiaozhigongqingjiajilu/tijiao',
      data: { id: item.id }
    }
    actionPost(o).then((res) => {
      if (res.code === 200) {
        bindTable()
        successPrompt(res.message)
      } else {
        warningPrompt(res.message)
      }
    })
  })
}
const qjsj = ref([]) // 请假时间
const qjsjChange = () => {
  ruleForm.value.sjqjkssj = qjsj.value[0]
  ruleForm.value.sjqjjssj = qjsj.value[1]
}

const submitForm = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  const data = {
    menuId: sessionStorage.getItem('menuId'),
    id: xiaojiaid.value,
    sjqjts: ruleForm.value.sjqjts,
    sjqjkssj: ruleForm.value.sjqjkssj,
    sjqjjssj: ruleForm.value.sjqjjssj
  }
  const options = {
    url: '/api/v2/jiaowu/jiaozhigongqingjiajilu/xiaojia',
    data: data
  } // [url]接口地址 [data]
  actionPost(options).then((res) => {
    if (res.code === 200) {
      centerDialogVisible.value = false
      bindTable()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 生效
const shengxiaoClick = (row) => {
  ElMessageBox.confirm('确定生效吗?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    const data = {
      menuId: sessionStorage.getItem('menuId'),
      id: row.id
    }
    const options = {

      url: '/api/v2/jiaowu/jiaozhigongqingjiajilu/shengxiao',
      data: data
    } // [url]接口地址 [data]
    actionPost(options).then((res) => {
      if (res.code === 200) {
        bindTable()
        successPrompt(res.message)
      } else {
        warningPrompt(res.message)
      }
    })
  })
}

// 加载 教职工请假状态 下拉框
const qjztData = ref({})
// 加载 教职工请假类型 下拉框
const jzgqjlxData = ref([])
// 加载 教职工销假状态 下拉框
const xjztData = ref([])

// 列表
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'qjkssj', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.zt = dataGrid.value.parms.zt === '' ? undefined : dataGrid.value.parms.zt
  dataGrid.value.parms.qjlxid = dataGrid.value.parms.qjlxid || undefined
  loadList({
    url: '/api/v2/jiaowu/jiaozhigongqingjiajilu/wodepagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 弹窗
const tcRow = ref({})
const openAdd = ref(false)
const openEdit = ref(false)
const openDetail = ref(false)
const openList = ref(false)

// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/jiaowu/jiaozhigongqingjiajilu',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function (res) {
      bindTable()
    }
  })
}

watch(
  () => props.open,
  () => {
    if (props.open === 'qingjia') {
      openList.value = true
      loadZiDianSelect('教职工请假类型', jzgqjlxData, 'sx', 'asc')
      loadSelect({ url: '/api/v2/jiaowu/jiaozhigongqingjiajilu/jiaozhigongzhuangtai', data: qjztData })
      loadSelect({ url: '/api/v2/jiaowu/jiaozhigongqingjiajilu/jiaozhigongxiaojiazhuangtai', data: xjztData })
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
